var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row g-2 wrap"},_vm._l((_vm.badges),function(badge,i){return _c('Badge',_vm._b({key:`${badge.value}_${i}`,attrs:{"data-key":`${badge.value}_${i}`}},'Badge',badge,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }